/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Batch is content that has been deposited into the Windows Integration Server and not yet identified as a specific content type.
 * @export
 * @interface Batch
 */
export interface Batch {
    /**
     * Content identifier
     * @type {string}
     * @memberof Batch
     */
    contentId?: string;
    /**
     * 
     * @type {string}
     * @memberof Batch
     */
    contentType: BatchContentTypeEnum;
    /**
     * Department code.
     * @type {string}
     * @memberof Batch
     */
    department: string;
    /**
     * SFTP deposit location and path
     * @type {string}
     * @memberof Batch
     */
    depositLocation?: string;
    /**
     * Datetime batch was uploaded to Windows Integration Server
     * @type {Date}
     * @memberof Batch
     */
    depositedAt?: Date;
    /**
     * Identifier of batch
     * @type {number}
     * @memberof Batch
     */
    id: number;
    /**
     * url/location of WIS manifest
     * @type {string}
     * @memberof Batch
     */
    manifestLocation?: string;
    /**
     * Name of the batch
     * @type {string}
     * @memberof Batch
     */
    name?: string;
    /**
     * Number
     * @type {string}
     * @memberof Batch
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof Batch
     */
    status: BatchStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof Batch
     */
    statusUpdatedAt: Date;
    /**
     * Bucket upload location
     * @type {string}
     * @memberof Batch
     */
    storageKey?: string;
    /**
     * Last known Temporal workflow identifier
     * @type {string}
     * @memberof Batch
     */
    temporalWorkflowId?: string;
    /**
     * 
     * @type {Date}
     * @memberof Batch
     */
    timeCompleted?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Batch
     */
    timeStarted?: Date;
    /**
     * Returns the duration of the batch in seconds
     * @type {number}
     * @memberof Batch
     */
    timeTaken?: number;
    /**
     * Name of the Agency that transferred the batch to SDPS
     * @type {string}
     * @memberof Batch
     */
    transferringAgency?: string;
}


/**
 * @export
 */
export const BatchContentTypeEnum = {
    Transfer: 'Transfer',
    Sip: 'SIP',
    Aip: 'AIP',
    Dip: 'DIP',
    PackageStatusUpdates: 'Package Status Updates',
    WorkflowDefinition: 'Workflow Definition',
    DisseminationRequest: 'Dissemination Request',
    ReingestRequest: 'Reingest Request',
    FileFormatCategoryChanges: 'File Format Category Changes',
    Unknown: 'Unknown',
    SystemConfigurationUpdates: 'System Configuration Updates'
} as const;
export type BatchContentTypeEnum = typeof BatchContentTypeEnum[keyof typeof BatchContentTypeEnum];

/**
 * @export
 */
export const BatchStatusEnum = {
    Received: 'Received',
    Accepted: 'Accepted',
    Failed: 'Failed',
    Identified: 'Identified'
} as const;
export type BatchStatusEnum = typeof BatchStatusEnum[keyof typeof BatchStatusEnum];


/**
 * Check if a given object implements the Batch interface.
 */
export function instanceOfBatch(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contentType" in value;
    isInstance = isInstance && "department" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "statusUpdatedAt" in value;

    return isInstance;
}

export function BatchFromJSON(json: any): Batch {
    return BatchFromJSONTyped(json, false);
}

export function BatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): Batch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contentId': !exists(json, 'content_id') ? undefined : json['content_id'],
        'contentType': json['content_type'],
        'department': json['department'],
        'depositLocation': !exists(json, 'deposit_location') ? undefined : json['deposit_location'],
        'depositedAt': !exists(json, 'deposited_at') ? undefined : (new Date(json['deposited_at'])),
        'id': json['id'],
        'manifestLocation': !exists(json, 'manifest_location') ? undefined : json['manifest_location'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'status': json['status'],
        'statusUpdatedAt': (new Date(json['status_updated_at'])),
        'storageKey': !exists(json, 'storage_key') ? undefined : json['storage_key'],
        'temporalWorkflowId': !exists(json, 'temporal_workflow_id') ? undefined : json['temporal_workflow_id'],
        'timeCompleted': !exists(json, 'time_completed') ? undefined : (new Date(json['time_completed'])),
        'timeStarted': !exists(json, 'time_started') ? undefined : (new Date(json['time_started'])),
        'timeTaken': !exists(json, 'time_taken') ? undefined : json['time_taken'],
        'transferringAgency': !exists(json, 'transferring_agency') ? undefined : json['transferring_agency'],
    };
}

export function BatchToJSON(value?: Batch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content_id': value.contentId,
        'content_type': value.contentType,
        'department': value.department,
        'deposit_location': value.depositLocation,
        'deposited_at': value.depositedAt === undefined ? undefined : (value.depositedAt.toISOString()),
        'id': value.id,
        'manifest_location': value.manifestLocation,
        'name': value.name,
        'number': value.number,
        'status': value.status,
        'status_updated_at': (value.statusUpdatedAt.toISOString()),
        'storage_key': value.storageKey,
        'temporal_workflow_id': value.temporalWorkflowId,
        'time_completed': value.timeCompleted === undefined ? undefined : (value.timeCompleted.toISOString()),
        'time_started': value.timeStarted === undefined ? undefined : (value.timeStarted.toISOString()),
        'time_taken': value.timeTaken,
        'transferring_agency': value.transferringAgency,
    };
}

